import { isPlatformBrowser } from '@angular/common';
import { ChangeDetectionStrategy, Component, computed, inject, PLATFORM_ID } from '@angular/core';
import { MatIcon } from '@angular/material/icon';
import { RouterLink } from '@angular/router';
import {
  RelatedPage,
  RelatedPagesComponent,
} from '../../partials/components/related-pages/related-pages.component';

@Component({
  selector: 'app-wallet-screening',
  imports: [MatIcon, RouterLink, RelatedPagesComponent],
  templateUrl: './wallet-screening.component.html',
  styleUrl: './wallet-screening.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class WalletScreeningComponent {
  protected readonly relatedPages: RelatedPage[] = [
    {
      link: '/aml-check',
      anchor: "Online AML check",
      text: "Run a check on a single wallet or transaction and read the result across four AML data providers.",
    },
    {
      link: '/transaction-monitoring',
      anchor: "Crypto transaction monitoring",
      text: "Screening answers for one moment. Monitoring keeps the same wallet under watch and tells you when it changes.",
    },
    {
      link: '/aml-compliance-software',
      anchor: "AML compliance software",
      text: "The whole platform behind the screening: checks, monitoring, alerts, team roles and the API.",
    },
  ];

  private readonly _platformId = inject(PLATFORM_ID);

  readonly createAccountHref = computed(() => {
    if (!isPlatformBrowser(this._platformId)) {
      return 'https://app.amlofficer.org/register-corporate-account';
    }

    const referralLink = localStorage.getItem('referralLink');
    const trackingLink = localStorage.getItem('trackingLink');
    const queryParams = new URLSearchParams();
    if (referralLink) {
      queryParams.set('referralLink', referralLink);
    }
    if (trackingLink) {
      queryParams.set('trackingLink', trackingLink);
    }
    const query = queryParams.toString();
    return query
      ? `https://app.amlofficer.org/register-corporate-account?${query}`
      : `https://app.amlofficer.org/register-corporate-account`;
  });
}
